const parties = Array.from(document.querySelectorAll(".party"));

const button = document.querySelector(".show-more-parties");

let visibleParties = 9;

button.addEventListener("click", () => {
  visibleParties += 6;
  updateVisibleParties();
});

function updateVisibleParties() {
  parties.slice(0, visibleParties).forEach(partyElement => {
    partyElement.style.display = "block";
  });

  if (visibleParties >= parties.length) {
    button.style.display = "none";
  } else {
    const lastParty = parties[visibleParties - 1];
    const updateHeight = () => {
      button.style.height = lastParty.getBoundingClientRect().height + 'px';
    };
    lastParty.querySelector('img').onload = updateHeight;
    updateHeight();
  }
  setTimeout(() => {
    window.macy.recalculate(true);
  }, 100);
}

document.addEventListener('DOMContentLoaded', () => {
  updateVisibleParties();
});
